import * as React from 'react';

export const CONTENT_ROOT_ID = 'content-root';

export const useContentScroll = () => {
  const [scrollTop, setScrollTop] = React.useState(0);

  React.useEffect(() => {
    const contentEl = document.getElementById(CONTENT_ROOT_ID);

    const setScroll = () => {
      setTimeout(() => {
        setScrollTop(() => contentEl?.scrollTop ?? 0);
      }, 200);
    };

    contentEl?.addEventListener('scroll', setScroll, { passive: true });

    return () => contentEl?.removeEventListener('scroll', setScroll);
  }, []);

  return scrollTop;
};
